export default __webpack_public_path__ + "static/media/vk.aacb54b4.svg";